var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3110_5760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.375 18.625 0 12 0C5.375 0 0 5.375 0 12C0 18.625 5.375 24 12 24C18.625 24 24 18.625 24 12ZM13.4917 5.825C13.2083 5.25833 12.6333 4.9 12 4.9C11.3667 4.89167 10.7917 5.25 10.5083 5.825L5.825 15.2C5.70833 15.425 5.65 15.6833 5.65 15.9417C5.65 16.8583 6.4 17.6083 7.31667 17.6083H16.6833C16.9417 17.6083 17.1917 17.55 17.425 17.4333C18.25 17.025 18.5833 16.025 18.175 15.2L13.4917 5.825ZM9.48333 5.30833C9.95833 4.35 10.9333 3.75 12 3.75C13.0667 3.75 14.0417 4.35 14.5167 5.30833L19.2083 14.6917C19.4083 15.0833 19.5083 15.5167 19.5083 15.95C19.5083 17.5 18.2417 18.7583 16.6917 18.7583H7.31667C6.88333 18.7583 6.45 18.65 6.05833 18.4583C4.66667 17.7583 4.10833 16.075 4.8 14.6833L9.48333 5.30833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3110_5760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.c4b4ee36e6512371544a3aee35a2b320.svg";
export { ForwardRef as ReactComponent };